import C from "../constants";
const adminLoading = (state = false, action) => {
  switch (action.type) {
    case C.SET_ADMIN_LOADING:
      return action.payload;
    default:
      return state;
  }
};

export default adminLoading;
